export default [
	{
		/**
	   	 * 首页Tab关怀 -> 未完成宣教页
 		*/
		path: "/care/noCompletePreach",
		name: "noCompletePreach",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigate/no-complete-preach")), "noCompletePreach"),
		meta: {
			title: "未完成宣教"
		}
	},
	/**
		   * 首页Tab关怀 -> 已完成宣教页
		*/
	{
		path: "/care/completePreach",
		name: "completePreach",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigate/complete-preach")), "completePreach"),
		meta: {
			title: "已完成宣教"
		}
	},
	/**
		   * 首页Tab关怀 -> 未完成调查页
		*/
	{
		path: "/care/noCompleteInvestigate",
		name: "noCompleteInvestigate",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigate/no-complete-investigate")), "noCompleteInvestigate"),
		meta: {
			title: "未完成调查"
		}
	},
	/**
		   * 首页Tab关怀 -> 已完成调查页
		*/
	{
		path: "/care/completeInvestigate",
		name: "completeInvestigate",
		component: resolve => require.ensure([], () => resolve(require("@/views/preachInvestigate/complete-investigate")), "completeInvestigate"),
		meta: {
			title: "已完成调查"
		}
	},
	{
		path: "/care/investigateDetail",
		name: "investigateDetail",
		component: resolve => require.ensure([], () => resolve(require("@/views/investigateDetail/investigate-follow-detail")), "investigateDetail"),
		meta: {
			title: "随访表单"
		}
	},
	{
		path: "/care/investigateSatisfiedDetail",
		name: "investigateDetail",
		component: resolve => require.ensure([], () => resolve(require("@/views/investigateDetail/investigate-satisfied-detail")), "investigateDetail"),
		meta: {
			title: "满意度表单"
		}
	}
];



// WEBPACK FOOTER //
// ./src/router/preachInvestigate.js